export default __webpack_public_path__ + "static/media/SidebarImage-v2.a152f01a.webp";